export default __webpack_public_path__ + "static/media/practice-test-3.8bda8804.csv";